import React from "react";

import { ReentryInscriptionDTO } from "../../models/EnrollmentUpdateDTO";
import { RequestPromotionDTO } from "../../models/EnrollmentHistoryDTO";

/*
	Inscripción (Reingreso) (Esteban, 2026-10-21): el reingreso de Actualizaciones carga una inscripción nueva a precio de lista del
	horario destino (horario ?? módulo ?? curso). La promo de inscripción del plantel viene marcada; quitarla cobra la lista.
	value: null = la de por defecto, 0 = quitada, id = esa promo. Sin precio no se ve nada (no se carga inscripción).
*/

const num = (n: number) => (Math.round((Number(n) || 0) * 100) / 100).toLocaleString("es-MX", { maximumFractionDigits: 2 });

/** Lo que se manda en promotion para el reingreso a ese horario. */
export const promoDeReingreso = (scheduleId: number, value: number | null): RequestPromotionDTO =>
	({ items: [{ scheduleId, promotionId: null, inscriptionPromotionId: value }] });

interface Props { info: ReentryInscriptionDTO | null | undefined; value: number | null; onChange: (v: number | null) => void; busy: boolean; }

const InscripcionReingreso: React.FC<Props> = ({ info, value, onChange, busy }) => {
	if (!info || !(info.price > 0)) return null;
	const buenas = info.promotions.filter((p) => p.eligible);
	const id = value === null ? info.defaultPromotionId : (value || null);
	const promo = id ? buenas.find((p) => p.id === id) || null : null;
	const sym = info.currencySymbol || "";
	const mostrar = promo || buenas.find((p) => p.id === info.defaultPromotionId) || buenas[0];
	return (
		<div className="wau-caja" style={{ marginTop: 10 }}>
			<span className="wau-lab">{info.title}</span>
			{mostrar ? (
				<label style={{ position: "static", display: "flex", gap: 10, alignItems: "center", marginTop: 6, fontSize: 15, minHeight: 44, whiteSpace: "normal", maxWidth: "100%", cursor: "pointer" }}>
					<input type="checkbox" style={{ width: 22, height: 22, flex: "0 0 22px" }} checked={!!promo} disabled={busy}
						onChange={(e) => onChange(e.target.checked ? (info.defaultPromotionId ?? mostrar.id) : 0)} />
					<span>{mostrar.name}{" "}
						<span style={{ color: "var(--wa-apagado)", whiteSpace: "nowrap" }}>{promo
							? <>Inscripción <s>{sym}{num(info.price)}</s> → <b>{sym}{num(promo.total)}</b></>
							: <>Inscripción a Precio de Lista <b>{sym}{num(info.price)}</b></>}</span></span>
				</label>
			) : (
				<div style={{ fontSize: 15, marginTop: 6 }}>Inscripción a Precio de Lista <b>{sym}{num(info.price)}</b></div>
			)}
		</div>
	);
};

export default InscripcionReingreso;
